import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';

const AppRoutes: Routes = [
  { path: '', redirectTo: '/common/sign-in', pathMatch: 'full' },
  { path: 'sign-out', redirectTo: '/common/sign-in', pathMatch: 'full' },
  { path: 'common', loadChildren: './common/common.module#CommonCommponentModule'},
  { path: 'app', component: LayoutComponent },
  { path: '**', redirectTo: '/common/404', pathMatch: 'full' },
];

export const AppRoutingModule = RouterModule.forRoot(AppRoutes, {useHash: true});



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/app-routing.module.ts